import React from 'react'
import { useLocation, useNavigate } from 'react-router';
import "../../assets/css/inbox.css";
import "../../assets/css/responsive.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/css/style.css";

const ResourceView = () => {
    const params=useLocation();
    const navigate=useNavigate();
    console.log(params);
  return (
    <div className="sidebar_open">
       <div className="col-md-12 ">
        <div class="row d-flex align-items-center">
          <div class=" onbording-name-div">
             <li className="list-group-item bordes-div">
              <div className="row d-flex align-items-center">
                <div className=" onbording-name-div col-md-7 mt-2">
                  <p class="form-name res-tittle my-1" onClick={()=>{navigate('/dashboard/resources')}}>Resources</p>
                </div>
              
              </div>
            </li></div></div></div>
      <div className='doct-upload-div'>
    
      <iframe title='example'
        src={params?.state?.item?.path}
        width='100%'
        height='100%'
        className='frame-view'/>
    </div>
    </div>
  )
}

export default ResourceView